module.exports = __webpack_public_path__ + "components/app-promo/static/play-store_badge--black-d6047ec4f16adc0e4e80a778c8afd45d.svg";